import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import { Helmet } from "react-helmet-async";

function Home() {
  const [latestPosts, setLatestPosts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetch("/uploads/blog_posts.json")
      .then(response => response.json())
      .then(data => {
        const sortedPosts = data.sort((a, b) => new Date(b.date) - new Date(a.date));
        setLatestPosts(sortedPosts.slice(0, 3));
      })
      .catch(error => console.error("Error fetching posts:", error));
  }, []);

  return (
    <Layout>
      <Helmet>
        <title>Home | Croquette</title>
      </Helmet>
      <header className="text-3xl font-bold text-blue-600 text-center mb-8">
        HELLO WORLD !!!!!! HAPPY MEETING YOU! :D
      </header>
      <p className="text-center">The world is a canvas to our imagination - <span className="italic">A philosopher, 200 years ago</span></p>

      <h2
        className="text-2xl font-bold text-center mt-6 cursor-pointer text-blue-600 hover:underline"
        onClick={() => navigate("/blog")}
      >
        Latest Blog Posts
      </h2>
      <div className="mt-4 mx-auto w-full max-w-md space-y-4 px-4">
        {latestPosts.length === 0 ? (
          <p className="text-center">Loading...</p>
        ) : (
          latestPosts.map(post => (
            <div
              key={post.id}
              className="p-4 border rounded shadow text-center cursor-pointer hover:bg-gray-100"
              onClick={() => navigate("/blog")}
            >
              <h3 className="text-lg font-semibold">{post.title}</h3>
              <p className="text-gray-600 text-sm">{post.date}</p>
              <p className="mt-2 text-sm">{post.content}</p>
            </div>
          ))
        )}
      </div>
    </Layout>
  );
}

export default Home;
